export const transformReclamoPayload = (formData) => {
  const optionalFields = [
    'apellidoPaterno',
    'apellidoMaterno',
    'departamento',
    'provincia',
    'distrito',
    'telefonoFijo',
    'bienContratado',
    'monto',
    'tipoReclamo',
    'pedido',
    'menorEdad',
    'tipoDocumentoApoderado',
    'documentoApoderado',
    'nombreApoderado',
    'apellidoPaternoApoderado',
    'apellidoMaternoApoderado',
    'telefonoFijoApoderado',
    'telefonoCelularApoderado',
    'emailApoderado',
  ];

  const transformed = { ...formData };

  optionalFields.forEach((field) => {
    if (transformed[field] === undefined || transformed[field] === null) {
      transformed[field] = '';
    }
  });

  return transformed;
};

